var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32650)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#00BFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.73062 11.7574H4.6755V14.0625H3.375V6.25781H4.64625V6.61781H4.69631C5.14012 6.19256 5.70544 6.18075 6.02269 6.18075C7.35244 6.18075 8.22431 7.44806 8.22431 9.14062V9.36C8.22431 11.1212 7.21519 12.1708 6.00019 12.1708C5.4315 12.1725 5.01019 12.0426 4.73062 11.7574ZM7.01662 9.46463V9.08044C7.01662 7.97794 6.59644 7.2405 5.84775 7.2405C5.03887 7.2405 4.60519 8.09775 4.60519 9.08044V9.46294C4.60519 10.3995 5.03212 11.1167 5.87025 11.1167C6.53006 11.1144 7.01662 10.6003 7.01662 9.46463ZM8.85375 3.9375H10.1559V12.1365H8.85375V3.9375ZM13.8763 7.54256C13.1462 7.54256 12.4211 8.12194 12.4211 8.85431V12.1416H11.1263V6.31294H12.3261V6.67125H12.375C12.6664 6.36412 13.3791 6.22012 13.9652 6.22856C14.0237 6.22856 13.9753 6.23025 14.0321 6.23025L14.0389 7.54256H13.8763ZM13.3296 10.7409H14.625V12.1365H13.3296V10.7409Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32650"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlr);
export default __webpack_public_path__ + "static/media/plr.81baf49b12026ed93c0ca6eec9610abe.svg";
export { ForwardRef as ReactComponent };